import React, { useContext } from 'react';
import { ProductName } from 'anf-core-react';
import ProductReviews from '../../features/ProductReviews/ProductReviews';
import GarmentMeasurementSection from '../../features/GarmentMeasurements/GarmentMeasurementSection';
import ProductPageContext from '../../contexts/ProductPageContext';
import HorizontalLineSeparator from '../HorizontalSeparator/HorizontalSeparator';

export default function ProductInfo({
  brand,
  garmentMeasurements,
  productName,
  hasGarmentMeasurements,
}) {
  const ProductPageState = useContext(ProductPageContext);

  const {
    tmntData, type,
  } = ProductPageState;

  return (
    <div className="size-guide-info-wrapper-mfe">
      <ProductName brand={brand} size="l">
        <h2 className="product-title-component product-title-main-header">
          {productName}
        </h2>
      </ProductName>
      {type !== 'exchange' ? (
        <ProductReviews
          dataBvShow="rating_summary"
        />
      ) : ''}
      {hasGarmentMeasurements && (
        <>
          <HorizontalLineSeparator />
          <GarmentMeasurementSection
            textContent={tmntData}
            garmentMeasurements={garmentMeasurements}
          />
        </>
      )}
    </div>
  );
}
